import { useQuery } from "react-query";

import { searchService } from "services";

type UseAgentSearchQueryProps = {
	pattern: string;
	page: number;
	options?: any;
};

const useAgentSearchQuery = ({
	pattern,
	page,
	options,
}: UseAgentSearchQueryProps) =>
	useQuery(
		["agentSearch", pattern, page],
		() =>
			searchService.getAgents({
				pattern,
				page,
			}),
		{
			...options,
		},
	);

export default useAgentSearchQuery;
